<div class="controls-container" [ngClass]='{"controls-container-three-image": showThreeImages, "controls-container-historic": videoLogService.showHistoricVideoLog}'  [hidden]="!videoLogService.image">
    <button class="btn btn-grouped control" title="Navigate to previous segment"
            (click)="videoLogService.goToPreviousSegment()" [disabled]="!videoLogService.canGoToPreviousSegment">
        <span class="icon-ui-reverse"></span>
    </button>
    <button class="btn btn-grouped control" title="Navigate to beginning of segment"
            (click)="videoLogService.goToFirstOffset()" [disabled]="!videoLogService.canGoToFirstOffset">
        <span class="icon-ui-beginning"></span>
    </button>
    <button class="btn btn-grouped control" title="Navigate to previous image"
            (click)="videoLogService.goToPreviousOffset()" [disabled]="!videoLogService.canGoToPreviousOffset">
        <span class="icon-ui-left"></span>
    </button>
    <button class="btn btn-grouped control" title="Play video" (click)="videoLogService.startOrStopVideo()">
        <span class="icon-ui-play" *ngIf="videoLogService.playerState !== 'play'"></span>
        <span class="icon-ui-pause" *ngIf="videoLogService.playerState === 'play'"></span>
    </button>
    <button class="btn btn-grouped control" title="Navigate to next image" (click)="videoLogService.goToNextOffset()"
            [disabled]="!videoLogService.canGoToNextOffset">
        <span class="icon-ui-right"></span>
    </button>
    <button class="btn btn-grouped control" title="Navigate to end of segment"
            (click)="videoLogService.goToLastOffset()" [disabled]="!videoLogService.canGoToLastOffset">
        <span class="icon-ui-end"></span>
    </button>
    <button class="btn btn-grouped control" title="Navigate to next segment"
            (click)="videoLogService.goToNextSegment()" [disabled]="!videoLogService.canGoToNextSegment">
        <span class="icon-ui-forward"></span>
    </button>
</div>

<div class="historic-video-selector-container" [hidden]="!videoLogService.showHistoricVideoLog">
    <form class="historic-video-selector">
        <input #yearSelector type="range" name="yearSelector" [value]="videoLogService.currentYearIndex"
               [max]="videoLogService.yearRange?.yearIndexMax" [min]="0" list="steplist"
               (ngModelChange)="onYearSelect($event)" [ngModel]="videoLogService.currentYearIndex">
        <datalist id="steplist">
            <option *ngFor="let yearIndex of videoLogService.yearRange?.yearIndices" [value]="yearIndex"
                    [label]="videoLogService.yearRange?.years[yearIndex]"></option>
        </datalist>
    </form>
</div>

<div #menuToggle class="menu-toggle control top-control" [ngStyle]="{'top':topPxBtn, 'bottom':bottomPx}" (click)="showMenu = !showMenu">
    <span class="icon-ui-menu"></span>
</div>
<div #menuContainer class="menu-container" [ngClass]='{"menu-container-three-image": showThreeImages}' [hidden]="!showMenu" title="Adjust Display Rate">
    <form class="playerSpeedSetting calcite-slider" style="margin-bottom: 16px;">
        <span for="speedSlider">Playback speed</span>
        <input type="range" name="speedSlider" [min]="videoLogService.playerSetting.minSpeed"
               [max]="videoLogService.playerSetting.maxSpeed" [step]="videoLogService.playerSetting.step"
               [(ngModel)]="videoLogService.playerSpeed">
        <span id="speedsliderOutput">&nbsp;{{ videoLogService.playerSpeed }} &nbsp;Seconds</span>
    </form>
    <label class="toggle-switch modifier-class clearfix" title="State Route Intersection Dialog" *ngIf="!hideIntersectionDialogs && !isPopUp">
        <span class="toggle-switch-label left font-size--1">Show State Route Intersections</span>
        <input type="checkbox" class="toggle-switch-input" [checked]="videoLogService.crsSelection"
               (click)="videoLogService.toggleCrsSelection()">
        <span class="toggle-switch-track right"></span>
    </label>
    <label class="toggle-switch modifier-class clearfix" title="Local Roads Intersection Dialog" *ngIf="!hideIntersectionDialogs && !isPopUp">
        <span class="toggle-switch-label left font-size--1">Show Local Intersections</span>
        <input type="checkbox" class="toggle-switch-input" [checked]="videoLogService.findinxlist"
               (click)="videoLogService.togglefindinxlist()">
        <span class="toggle-switch-track right"></span>
    </label>
    <label class="toggle-switch modifier-class clearfix" *ngIf="videoLogService.canCrossSegments" title="Automatically jump to the next segment">
        <span class="toggle-switch-label left font-size--1">Enable Auto Run</span>
        <input type="checkbox" class="toggle-switch-input" [checked]="!videoLogService.isPromptAtBoundary"
               (click)="videoLogService.togglePromptAtBoundary()">
        <span class="toggle-switch-track right"></span>
    </label>
    <label class="toggle-switch modifier-class clearfix" *ngIf="videoLogService.image" title="Show full-sized images in player">
        <span class="toggle-switch-label left font-size--1">Fullsize Image</span>
        <input type="checkbox" class="toggle-switch-input" [checked]="videoLogService.imageServerFolder === '/fullsize'"
               (click)="videoLogService.toggleFullsizeImages()">
        <span class="toggle-switch-track right"></span>
    </label>
    <label class="toggle-switch modifier-class clearfix" *ngIf="videoLogService.image && !isPopUp" title="Highlight Segments">
        <span class="toggle-switch-label left font-size--1">Highlight Segments</span>
        <input type="checkbox" class="toggle-switch-input" [checked]="videoLogService.segHighlightEnabled" (click)="videoLogService.toggleSegmentHighlight()">
        <span class="toggle-switch-track right"></span>
    </label>
    <label class="download-images" *ngIf="!hideDownloadBtn && videoLogService.image" (click)="videoLogService.downloadImages()" title="Download 15 offset images beginning from the current offset">
        <span>Download Images</span>
        <span class="icon-ui-download right"></span>
    </label>
    <label class="modifier-class clearfix" [hidden]="!allowZoomTypeChange" title="Set map zoom and follow configuration"
           style="margin: -8px 0 16px;">
        <span for="zoomType" class="font-size--1">Zoom Type</span>
        <select name="zoomType" [(ngModel)]="videoLogService.zoomOnPositionChange" class="font-size--3 inline-block" style="margin-left: 9px;">
            <option value="none" title="Don't zoom to or follow the marker">None</option>
            <option value="follow" title="Follow the marker but don't zoom to it">Follow</option>
            <option value="zoom" title="Follow the marker and stay zoomed in">Zoom and Follow</option>
            <option value="first" title="Follow the marker but only zoom in when selecting a location">Zoom on Click and Follow</option>
        </select>
    </label>
    <label class="modifier-class clearfix" [title]="'Set zoom amount, the lower the number the more zoomed out. Current level: ' + videoLogService.followZoomLevel" style="margin-bottom: 16px"
           [hidden]="!allowZoomTypeChange || (allowZoomTypeChange && !(videoLogService.zoomOnPositionChange === 'zoom' || videoLogService.zoomOnPositionChange === 'first'))">
        <span for="zoomSlider" class="font-size--1">Zoom Level</span>
        <span class="inline-block" style="text-align: right;">
            <span class="font-size--3">Far</span>
            <input type="range" name="zoomSlider" class="inline-block" style="width: 60%; vertical-align: middle; margin: 0 5px;"
                   [min]="0" [max]="23" [step]="1" [(ngModel)]="videoLogService.followZoomLevel">
            <span class="font-size--3">Near</span>
        </span>
    </label>
    <label class="toggle-switch modifier-class clearfix" title="Show Historic Videolog" style="margin-bottom: 0;">
        <span class="toggle-switch-label left font-size--1">Show Historic Videolog</span>
        <input type="checkbox" class="toggle-switch-input" [checked]="videoLogService.showHistoricVideoLog"
               (click)="videoLogService.toggleHistoricVideoLog()">
        <span class="toggle-switch-track right"></span>
    </label>
</div>

<div class="direction-changer control top-control" [ngStyle]="{'top':topPxBtn, 'bottom':bottomPx}" title="Change to opposite direction"
     (click)="videoLogService.reverseDirection()" [hidden]="!videoLogService.canReverseDirection || isPopUp">
    <span class="icon-ui-up-down-arrows" style="font-size: 20px;"></span>
</div>

<div class="toggle-image-toggles control top-control" [ngClass]='{"toggle-image-toggles-reverse" : videoLogService.canReverseDirection}'  (click)="toggleImageToggles = !toggleImageToggles" [hidden]="!videoLogService.image || !showThreeImages" title="Show/Hide Images">
    <span [ngClass]="toggleImageToggles ? 'icon-ui-minus' : 'icon-ui-plus'"></span>
</div>
<div class="toggle-image-button1 control top-control"
     [ngClass]="showLeftImage ? 'toggle-image-button1-on' : 'toggle-image-button1-off'"
     [ngStyle]="{'left': !videoLogService.canReverseDirection ? '50px' : '100px'}"
     [hidden]="!showThreeImages || !toggleImageToggles" (click)="toggleLeftImage()" title="Show/Hide Left Image">
    <span>L</span>
</div>
<div class="toggle-image-button2 control top-control"
     [ngClass]="showCenterImage ? 'toggle-image-button2-on' : 'toggle-image-button2-off'"
     [ngStyle]="{'left': !videoLogService.canReverseDirection ? '50px' : '100px'}"
     [hidden]="!showThreeImages || !toggleImageToggles" (click)="toggleCenterImage()" title="Show/Hide Center Image">
    <span>C</span>
</div>
<div class="toggle-image-button3 control top-control"
     [ngClass]="showRightImage ? 'toggle-image-button3-on' : 'toggle-image-button3-off'"
     [ngStyle]="{'left': !videoLogService.canReverseDirection ? '50px' : '100px'}"
     [hidden]="!showThreeImages || !toggleImageToggles" (click)="toggleRightImage()" title="Show/Hide Right Image">
    <span>R</span>
</div>
